import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { AssociateService } from '../shared/services/associate.service';

@Injectable()
export class AssociateResolver implements Resolve<any> {
    constructor(private associsateService: AssociateService) { }

    resolve(route: ActivatedRouteSnapshot) {
        console.log('Associate Id', route.params.id);
        return this.associsateService.getAssociate(route.params.id);
    }
}
